// slices/annualLeaveApiSlice.js
import { apiSlice } from './apiSlice';

export const annualLeaveApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // Preview calculation — does NOT write to DB
    previewAnnualLeave: builder.query({
      query: ({ startDate, endDate, userId }) => ({
        url: '/api/annual-leave/calculate',
        params: {
          startDate,
          endDate,
          ...(userId && { userId }),
        },
      }),
      providesTags: ['AnnualLeave'],
    }),

    // Apply calculation — writes newOpeningBalance to user records, never touches bringForward
    applyAnnualLeave: builder.mutation({
      query: ({ startDate, endDate, userIds = [] }) => ({
        url: '/api/annual-leave/apply',
        method: 'POST',
        body: { startDate, endDate, userIds },
      }),
      invalidatesTags: ['AnnualLeave', 'User'],
    }),

    // Get leave config singleton
    getLeaveConfig: builder.query({
      query: () => '/api/annual-leave/config',
      providesTags: ['LeaveConfig'],
    }),

    // Update leave config
    updateLeaveConfig: builder.mutation({
      query: (data) => ({
        url: '/api/annual-leave/config',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['LeaveConfig'],
    }),
  }),
});

export const {
  usePreviewAnnualLeaveQuery,
  useLazyPreviewAnnualLeaveQuery,
  useApplyAnnualLeaveMutation,
  useGetLeaveConfigQuery,
  useUpdateLeaveConfigMutation,
} = annualLeaveApiSlice;
